export const MAX_TXS_PER_PAGE = 50_000;
